import cvrLogo from "./cvr.svg";

let CVRBranding = {
  short: "CVR",
  title: "CVR Hub and Manage My Invoice Registration",
  logo: cvrLogo,
  description:
    "To register for CVR Hub you will need to enter the invoice information of the CMF that you want to access.",
  verificationSentText:
    "We have sent you an email containing a first time logon link, please use this link to access the CVR Hub."
};

let CDKBranding = {
  short: "CDK",
  title: "CDK Hub and Manage My Invoice Registration",
  description:
    "To register for CDK Hub you will need to enter the invoice information of the CMF that you want to access.",
  verificationSentText:
    "We have sent you an email containing a first time logon link, please use this link to access the CDK Hub."
};

let getBrand = () => {
  let hostname = window.location.hostname;
  if (hostname.includes("cvr")) {
    return CVRBranding;
  } else {
    return CDKBranding;
  }
};

export default getBrand;
